import React from 'react';
import { styled } from 'styled-components';
import { searchResultPadding } from './MediaSearchResult.styles';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { randomInRange } from '../../../../../play-core/utils/random';
import { TextPlaceholder } from '../../../components/Placeholder/TextPlaceholder';
import { delayedFadeIn } from '../SearchBar/SearchForm.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaSearchResultPlaceholder = () => /*#__PURE__*/_jsxs(Container, {
  children: [/*#__PURE__*/_jsx(ImagePlaceholder, {}), /*#__PURE__*/_jsxs(TextContainer, {
    children: [/*#__PURE__*/_jsx(TextPlaceholder, {
      width: randomInRange(40, 80),
      marginBottom: 21
    }), /*#__PURE__*/_jsx(TextPlaceholder, {
      width: randomInRange(85, 98)
    }), /*#__PURE__*/_jsx(TextPlaceholder, {
      width: randomInRange(85, 98)
    }), /*#__PURE__*/_jsx(TextPlaceholder, {
      width: randomInRange(20, 60)
    })]
  })]
});
const Container = styled.article.withConfig({
  displayName: "MediaSearchResultPlaceholder__Container",
  componentId: "sc-lzg51u-0"
})(["display:grid;grid-template-columns:auto 1fr;flex-direction:row;column-gap:60px;height:178px;background-color:", ";", "{height:92px;grid-column-gap:16px;}", ";animation:", " 150ms ease-in;"], Colors.GREY_1a1a1a, Viewports.for('small'), searchResultPadding, delayedFadeIn);
const TextContainer = styled.div.withConfig({
  displayName: "MediaSearchResultPlaceholder__TextContainer",
  componentId: "sc-lzg51u-1"
})(["flex-grow:1;display:flex;flex-direction:column;padding:20px 0;", "{margin-right:150px;}"], Viewports.for('xLargeUp'));
const ImagePlaceholder = styled.div.withConfig({
  displayName: "MediaSearchResultPlaceholder__ImagePlaceholder",
  componentId: "sc-lzg51u-2"
})(["display:flex;align-self:center;background-color:", ";width:300px;height:169px;border-radius:2px;", "{width:152px;height:86px;}"], Colors.GREY_3a3a3a, Viewports.for('small'));